<div class="main-content">
  <div class="container-fluid">

    <!-- Controls row -->
    <div class="admin-controls">
      <div class="filter-pills">
        <button (click)="changeFilter(EpeStatusFilter.all)"
                [class.active]="filter == EpeStatusFilter.all"
                class="pill">All</button>
        <button (click)="changeFilter(EpeStatusFilter.draft)"
                [class.active]="filter == EpeStatusFilter.draft"
                class="pill pill--default">Draft</button>
        <button (click)="changeFilter(EpeStatusFilter.pending)"
                [class.active]="filter == EpeStatusFilter.pending"
                class="pill pill--warning">Pending</button>
        <button (click)="changeFilter(EpeStatusFilter.eligible)"
                [class.active]="filter == EpeStatusFilter.eligible"
                class="pill pill--success">Eligible</button>
        <button (click)="changeFilter(EpeStatusFilter.not_eligible)"
                [class.active]="filter == EpeStatusFilter.not_eligible"
                class="pill pill--danger">Not Eligible</button>
        <button (click)="changeFilter(EpeStatusFilter.voted)"
                [class.active]="filter == EpeStatusFilter.voted"
                class="pill pill--info">Voted</button>
      </div>
      <div class="controls-right">
        <div class="search-wrap">
          <i class="fa fa-search search-icon"></i>
          <input class="form-control search-input"
                 placeholder="Search by name, email, organisation…"
                 [(ngModel)]="search"
                 (ngModelChange)="searchEpe($event)">
        </div>
        <button *ngIf="exportAuthorized()" class="btn btn-default export-btn" (click)="exportCSV()">
          <i class="fa fa-download"></i> Export CSV
        </button>
      </div>
    </div>

    <!-- Sort row -->
    <div class="sort-row">
      <span class="sort-label">Sort:</span>
      <button (click)="changeSort('name')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'name'">
        Name
        <i class="fa" [ngClass]="sortBy === 'name' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
      <button (click)="changeSort('surname')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'surname'">
        Surname
        <i class="fa" [ngClass]="sortBy === 'surname' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
      <button (click)="changeSort('score')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'score'">
        Score
        <i class="fa" [ngClass]="sortBy === 'score' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
    </div>

    <loader *ngIf="loading"></loader>

    <div *ngIf="!loading && getEpes().length === 0" class="empty-state">
      <i class="fa fa-inbox fa-2x"></i>
      <p>No applications match the current filter.</p>
    </div>

    <!-- Application list -->
    <div *ngIf="!loading" class="epe-list">
      <div *ngFor="let epe of getEpes()" class="epe-item">

        <!-- Summary row -->
        <div class="epe-summary" (click)="expand(getAppId(epe))">

          <div class="epe-id-col">
            <span class="user-name" *ngIf="epe.user_info?.name || epe.user_info?.surname">
              {{ epe.user_info?.name }} {{ epe.user_info?.surname }}
            </span>
            <span class="user-id">User&nbsp;#{{ epe.user_id || epe.id }}</span>
            <span class="label epe-status-badge" [ngClass]="getStatusBadgeClass(epe.status)">
              {{ getStatusLabel(epe.status) }}
            </span>
            <span *ngIf="isWarning(epe)" class="label label-warning warning-badge" title="High vote variance">
              <i class="fa fa-exclamation-triangle"></i>
            </span>
          </div>

          <div class="epe-info-col">
            <div class="epe-topics" *ngIf="getTopicLabels(epe).length > 0">
              <span *ngFor="let t of getTopicLabels(epe).slice(0, 3)" class="topic-mini">{{ t }}</span>
              <span *ngIf="getTopicLabels(epe).length > 3" class="topic-more">
                +{{ getTopicLabels(epe).length - 3 }} more
              </span>
            </div>
            <div class="epe-submitted">
              <span class="epe-submitted-label">Submitted</span>
              {{ epe.created_at | date:'d MMM yyyy' }}
            </div>
          </div>

          <div class="epe-right-col">
            <div *ngIf="epe.score" class="score-block">
              <span class="score-num">{{ truncateFloat(epe.score) }}</span>
              <span class="score-meta">/ 10<br><small>{{ epe.nvotes }} vote(s)</small></span>
            </div>
            <button class="btn btn-sm btn-action">
              <i class="fa" [ngClass]="selected === getAppId(epe) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              {{ selected === getAppId(epe) ? 'Close' : getBtnText(epe.status) }}
            </button>
          </div>

        </div>

        <!-- Expanded detail -->
        <div *ngIf="selected === getAppId(epe)" class="epe-detail">
          <div class="row">
            <!-- Left: user profile + form data -->
            <div class="col-md-8">

              <!-- Drupal user profile -->
              <div class="detail-section" *ngIf="epe.user_info">
                <h5 class="detail-section-title">User Profile</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Name</label><p>{{ epe.user_info.name || '—' }} {{ epe.user_info.surname || '' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Username</label><p>{{ epe.user_info.username || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Email</label><p>{{ epe.user_info.email || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Gender</label><p>{{ epe.user_info.gender || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Organisation</label><p>{{ epe.user_info.organisation || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Country</label><p>{{ epe.user_info.country || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="epe.user_info.organisation_type">
                    <div class="detail-field"><label>Organisation Type</label><p>{{ epe.user_info.organisation_type }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="epe.user_info.phone_number">
                    <div class="detail-field"><label>Phone</label><p>{{ epe.user_info.phone_number }}</p></div>
                  </div>
                </div>
              </div>

              <div class="detail-section">
                <h5 class="detail-section-title">Topics</h5>
                <div *ngIf="getTopicDetails(epe).length > 0; else topicBadges">
                  <div *ngFor="let td of getTopicDetails(epe)" class="group-card">
                    <div class="group-card-header">{{ td.label }}</div>
                    <div class="group-card-body">
                      <div class="detail-field"><label>Evidence of expertise</label><p>{{ td.evidence || '—' }}</p></div>
                      <div class="detail-field">
                        <label>Primary type of support offered</label>
                        <p>
                          <span *ngFor="let s of td.support" class="topic-badge-detail">{{ s }}</span>
                          <span *ngIf="!td.support.length" class="text-muted">—</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #topicBadges>
                  <div *ngIf="getTopicLabels(epe).length > 0; else noTopics">
                    <span *ngFor="let t of getTopicLabels(epe)" class="topic-badge-detail">{{ t }}</span>
                  </div>
                  <ng-template #noTopics><span class="text-muted">—</span></ng-template>
                </ng-template>
              </div>

              <div class="detail-section" *ngIf="epe.form_data?.standardisation_experience === 'yes' && epe.form_data?.sdo_member === 'yes'">
                <h5 class="detail-section-title">Standardisation Roles</h5>
                <div *ngFor="let role of epe.form_data?.standardisation_roles; let i = index" class="group-card">
                  <div class="group-card-header">Role #{{ i + 1 }}</div>
                  <div class="group-card-body">
                    <div class="row">
                      <div class="col-sm-8">
                        <div class="detail-field">
                          <label>SDO / NSB / NC</label>
                          <p>{{ role.sdo || '—' }}<span *ngIf="role.other_sdo" class="text-muted"> — {{ role.other_sdo }}</span></p>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="detail-field"><label>Years of Experience</label><p>{{ role.years_of_experience || '—' }}</p></div>
                      </div>
                      <div class="col-sm-4" *ngIf="role.tc_number">
                        <div class="detail-field"><label>TC / SC / WG No.</label><p>{{ role.tc_number }}</p></div>
                      </div>
                      <div class="col-sm-4" *ngIf="role.tc_title">
                        <div class="detail-field"><label>TC / SC / WG Title</label><p>{{ role.tc_title }}</p></div>
                      </div>
                      <div class="col-sm-4">
                        <div class="detail-field"><label>Role</label><p>{{ role.roles || '—' }}</p></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="detail-section">
                <h5 class="detail-section-title">Fit with HSbooster.eu II services</h5>
                <div class="detail-field" *ngIf="epe.form_data?.fit_support_approach">
                  <label>Standardisation support approach</label>
                  <p class="tell-us-more">{{ epe.form_data.fit_support_approach }}</p>
                </div>
                <div class="detail-field" *ngIf="epe.form_data?.fit_ri_experience">
                  <label>Experience supporting R&I projects</label>
                  <p class="tell-us-more">{{ epe.form_data.fit_ri_experience }}</p>
                </div>
                <div class="detail-field" *ngIf="epe.form_data?.fit_knowledge_valorisation">
                  <label>Knowledge valorisation experience</label>
                  <p class="tell-us-more">{{ epe.form_data.fit_knowledge_valorisation }}</p>
                </div>
                <div class="detail-field" *ngIf="epe.form_data?.fit_additional_expertise">
                  <label>Additional standardisation expertise</label>
                  <p class="tell-us-more">{{ epe.form_data.fit_additional_expertise }}</p>
                </div>
              </div>

              <div class="detail-section">
                <h5 class="detail-section-title">Availability, languages and preferences</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Indicative availability</label><p>{{ epe.form_data?.availability || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Time zone</label><p>{{ epe.form_data?.time_zone || '—' }}</p></div>
                  </div>
                </div>
                <div class="detail-field">
                  <label>Preferred types of services</label>
                  <p>
                    <span *ngFor="let s of epe.form_data?.preferred_services" class="topic-badge-detail">{{ s }}</span>
                    <span *ngIf="!epe.form_data?.preferred_services?.length" class="text-muted">—</span>
                  </p>
                </div>
                <div class="detail-field">
                  <label>Working languages</label>
                  <p>
                    <span *ngFor="let l of epe.form_data?.working_languages" class="topic-badge-detail">{{ l }}</span>
                    <span *ngIf="!epe.form_data?.working_languages?.length" class="text-muted">—</span>
                  </p>
                </div>
                <div class="detail-field" *ngIf="epe.form_data?.availability_limitations">
                  <label>Potential limitations on availability</label>
                  <p class="tell-us-more">{{ epe.form_data.availability_limitations }}</p>
                </div>
              </div>

              <div class="detail-section">
                <h5 class="detail-section-title">Declarations</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Confidentiality declaration</label><p>{{ epe.form_data?.confidentiality_declaration ? 'Agreed' : '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Accuracy declaration</label><p>{{ epe.form_data?.accuracy_declaration ? 'Agreed' : '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Data protection consent</label><p>{{ epe.form_data?.data_protection_consent ? 'Agreed' : '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Public profile consent</label><p>{{ epe.form_data?.public_profile_consent === 'yes' ? 'Yes' : (epe.form_data?.public_profile_consent === 'no' ? 'No' : '—') }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Newsletter subscription</label><p>{{ epe.form_data?.newsletter_subscription === 'yes' ? 'Yes' : (epe.form_data?.newsletter_subscription === 'no' ? 'No' : '—') }}</p></div>
                  </div>
                </div>
              </div>

              <div class="detail-section detail-links">
                <a *ngIf="epe.form_data?.cv"
                   [href]="'/api/v1/applications/cv-download/' + epe.form_data.cv"
                   target="_blank" rel="noopener" class="cv-link">
                  <i class="fa fa-file-pdf-o"></i> Download CV
                </a>
              </div>
            </div>

            <!-- Voting / eligibility panel -->
            <div class="col-md-4">
              <epe-sopcard-small (voteUpdated)="voteChangeDetector($event)" [epe]="epe"></epe-sopcard-small>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
